import { jsx as _jsx } from "react/jsx-runtime";
import { DateTime } from 'luxon';
function DateDisplay(props) {
    const date = props.date instanceof DateTime ? props.date : DateTime.fromISO(props.date);
    return (_jsx("time", { dateTime: date.toLocaleString(DateTime.DATE_MED), className: "time truncate", title: date.toLocaleString(DateTime.DATE_MED), children: date.toLocaleString(DateTime.DATE_MED) }));
}
export default DateDisplay;
